import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-canvas font-sans text-ink selection:bg-volt" data-id="element-0" data-mp="33oriy2lrxzq1">
      <noscript data-id="element-1" data-mp="38kgk2adfzoog">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="38o4h3ji3it7x" />
      </noscript>

      <Hero data-id="element-3" data-mp="sudkecc4nt77" />
      <main data-id="element-4" data-mp="su42lc18kscl">
        <ProblemSection data-id="element-5" data-mp="stkn01z26g1q" />
        <SolutionSection data-id="element-6" data-mp="ssspumptca9c" />
        <BonusesSection data-id="element-7" data-mp="swghthfm0oly" />
        <BenefitsSection data-id="element-8" data-mp="35yo8huu3i0e" />
        <OfferSection data-id="element-9" data-mp="356t1855fman" />
        <GuaranteeSection data-id="element-10" data-mp="34ndfy2z19zs" />
        <Testimonials data-id="element-11" data-mp="3uct3bjmdin0h" />
        <FAQSection data-id="element-12" data-mp="3udkos1m9b4d1" />
        <FinalCTA data-id="element-13" data-mp="3ubzu8bzxzlf6" />
      </main>
      <Footer data-id="element-14" data-mp="3uevui6z9im6s" />
      {showPurchasePopup && <PurchasePopup data-id="element-15" data-mp="d57fh2ybeij2" />}
    </div>;
}